import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToAuditLogEntry,
  type AuditLogEntry,
  type AuditLogEntryApiResource,
  type AuditLogQuery,
} from './auditApi.types';

const PLATFORM_AUDIT_LOGS_PATH = '/audit-logs';
const WORKSPACE_AUDIT_LOGS_PATH = '/me/workspace/audit-logs';

function buildAuditLogParameters(
  query: AuditLogQuery
): Record<string, string | number | undefined> {
  const trimmedSearch = query.search.trim();
  return {
    page: query.page,
    page_size: query.pageSize,
    search: trimmedSearch.length === 0 ? undefined : trimmedSearch,
    category: query.category === null ? undefined : query.category,
    client_id: query.clientId === null ? undefined : query.clientId,
    occurred_from: query.occurredFrom === null ? undefined : query.occurredFrom,
    occurred_until: query.occurredUntil === null ? undefined : query.occurredUntil,
  };
}

export async function fetchAuditLogs(
  query: AuditLogQuery,
  tenantId?: string
): Promise<PaginatedResult<AuditLogEntry>> {
  const response = await httpClient.get<PaginatedApiResource<AuditLogEntryApiResource>>(
    PLATFORM_AUDIT_LOGS_PATH,
    {
      params: {
        ...buildAuditLogParameters(query),
        tenant_id: tenantId === undefined ? undefined : tenantId,
      },
    }
  );
  return mapPaginatedResource(response.data, mapApiResourceToAuditLogEntry);
}

export async function fetchWorkspaceAuditLogs(
  query: AuditLogQuery
): Promise<PaginatedResult<AuditLogEntry>> {
  const response = await httpClient.get<PaginatedApiResource<AuditLogEntryApiResource>>(
    WORKSPACE_AUDIT_LOGS_PATH,
    { params: buildAuditLogParameters(query) }
  );
  return mapPaginatedResource(response.data, mapApiResourceToAuditLogEntry);
}
